import store from "./store"
import Vue from "vue"
import App from "./App"
import router from "./router"
import wechatAuth from './assets/js/wechatAuth'
//配置微信公众号的appid
Vue.use(wechatAuth, {
  appid: "wx2304e2389b7a909d",
  scope: 'snsapi_userinfo',
})
import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"

// 引入Vant UI组件库
import Vant from "vant"
import "vant/lib/index.css"
Vue.use(Vant)

import "@/assets/css/font.scss"
import axios from "./assets/js/axios.js"
import globalQuery from "./assets/js/globalQuery.js"
import getRecord from "./assets/js/getRecords.js"
import tool from "./assets/js/tool/index.js"
import "@/assets/css/reset.css"
import "@/assets/css/index.scss"
import "./assets/js/dataFormat.js"

// 引用公用组件
import Loading from "@/components/component/Loading"
Vue.use(Loading)
Vue.component("Loading", Loading)

// iconfont
// import '@/assets/font/iconfont.css';

import watermark from "@/assets/js/watermark.js"
Vue.prototype.$watermark = watermark
Vue.config.productionTip = false
Vue.use(Element)

//全局水印
Vue.prototype.$watermark = watermark
Vue.prototype.$axios = axios
Vue.prototype.$tool = tool
Vue.prototype.$globalQuery = globalQuery
Vue.prototype.$getRecord = getRecord

window.onload = function () {
  // 当一个手指放在屏幕上时，会触发 touchstart 事件。如果另一个手指又放在了屏幕上，则会先触发 gesturestart 事件
  document.addEventListener("gesturestart", function (e) {
    e.preventDefault()
  })

  // 在单个元素上单击两次 ===  dblclick
  document.addEventListener("dblclick", function (e) {
    e.preventDefault()
  })

  // 一个手指放在屏幕上时，会触发 touchstart 事件
  document.addEventListener("touchstart", function (e) {
    if (e.touches.length > 1) {
      e.preventDefault()
    }
  })

  // 如果一个或两个手指在屏幕上滑动，将会触发 gesturechange 事件
  // 但只要有一个手指移开， 就会触发 gestureend 事件，紧接着又会触发基于该手指的 touchend 事件
  var lastTouchEnd = 0
  document.addEventListener(
    "touchend",
    function (event) {
      var now = new Date().getTime()
      // 如果在300ms内触发两次touchend，就阻止默认事件
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    false
  )
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
